import * as React from 'react'
import injectSheet from 'react-jss'
import {WithClasses} from './Helper'
import TableCell from 'material-ui-next/Table/TableCell'

const styles = {
    root: {
        position: 'relative',
    },
    link: {
        display: 'block',
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
    },
    smallPadding: {
        padding: '0 8px !important'
    }
}

interface Properties {
    readonly href: string
    readonly children: React.ReactNode
    readonly numeric?: boolean
    readonly rowSpan?: number
    readonly smallPadding?: boolean
}

export const LinkTableCell =
    injectSheet<Properties>(styles)(
        ({classes, href, numeric, rowSpan, smallPadding, children}: WithClasses<Properties>) => (
            <TableCell
                className={smallPadding ? classes.root + ' ' + classes.smallPadding : classes.root}
                numeric={numeric}
                rowSpan={rowSpan}
            >
                <a
                    href={href}
                    className={classes.link}
                />
                {children}
            </TableCell>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/LinkTableCell.tsx